<div class="filter" aria-label="Filtro de busca de empresas">
  <div class="search-box search-box-status" aria-label="Filtro de status da empresa">
    <label for="statusEmpresa">Status Empresa</label>
    <select id="statusEmpresa" [formControl]="searchStatus" aria-label="Selecionar status da empresa">
      <option value="1">Ativo</option>
      <option value="2">Inativo</option>
      <option value="3">Todos</option>
    </select>
  </div>
  <div class="search-box" aria-label="Filtro de busca por CNPJ ou razão social">
    <select [formControl]="searchType" aria-label="Selecionar tipo de busca">
      <option value="1">BUSCA POR CNPJ</option>
      <option value="2">BUSCA POR RAZÃO SOCIAL</option>
    </select>
    <input
      *ngIf="searchType.value == 1"
      [(ngModel)]="filterText"
      placeholder="01.234.567/0001-00"
      [textMask]="{
        mask: fiscalNumberMask,
        guide: false,
        keepCharPositions: true
      }"
      (keypress)="onPressEnterSearchCompanies($event)"
      aria-label="Campo para buscar empresa por CNPJ" />
    <input
      *ngIf="searchType.value == 2"
      [(ngModel)]="filterText"
      placeholder="Razão Social"
      (keypress)="onPressEnterSearchCompanies($event)"
      aria-label="Campo para buscar empresa por razão social" />
    <button class="search-icon-container" type="button" (click)="searchCompanies(filterText)" aria-label="Botão para buscar empresa">
      <mat-icon aria-hidden="false">search</mat-icon>
    </button>
  </div>
</div>

<p *ngIf="!hasCompany()" aria-label="Mensagem de nenhum registro encontrado">Nenhum registro encontrado.</p>

<div *ngIf="hasCompany()" class="company-card-container" aria-label="Lista de empresas encontradas">
  <div class="search-control" aria-label="Controle de navegação da lista de empresas">
    <p aria-label="Quantidade de resultados encontrados">
      {{ pageableResult.getTotalItems() === 1 ? "1 RESULTADO ENCONTRADO" : pageableResult.getTotalItems() + " RESULTADOS ENCONTRADOS" }}
    </p>
    <button class="scroll-text" *ngIf="showScrollBottomBtn()" type="button" (click)="scrollToLastCompany()" aria-label="Ir para o fim da lista de empresas">
      <mat-icon aria-hidden="false">arrow_drop_down</mat-icon>
      <span class="btn-title">ir para o fim da lista</span>
    </button>
  </div>

  <div *ngFor="let company of pageableResult.getItems()">
    <div class="company-card" aria-label="Card da empresa">
      <div class="company-logo" aria-label="Logo da empresa">
        <img src="./assets/icons/no-logo-company-icon.svg" alt="Logo da empresa" />
      </div>
      <div class="company-data" aria-label="Dados da empresa">
        <p class="company-name" aria-label="Nome da empresa">{{ company.getCorporateName() }}</p>
        <p class="company-cnpj" aria-label="CNPJ da empresa">CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }}</p>
        <p class="company-description" aria-label="Nome fantasia da empresa">{{ company.getTradingName() }}</p>
      </div>
      <div class="company-status" aria-label="Status e ações da empresa">
        <div
          class="status"
          [ngStyle]="{
            'background-color': company.getIsActive() ? '#2DCD7A' : 'darkgray'
          }"
          aria-label="Status da empresa">
          <mat-icon *ngIf="company.getIsActive()" aria-label="Empresa ativa">check_circle_outline</mat-icon>
          <mat-icon *ngIf="!company.getIsActive()" aria-label="Empresa inativa">clear</mat-icon>
          <span class="btn-title">{{ company.getIsActive() ? "ATIVO" : "INATIVO" }}</span>
        </div>
        <button class="edit-btn" type="button" (click)="navigateToEditCompany(company.getFiscalNumber())" aria-label="Editar ou visualizar empresa">
          <mat-icon aria-hidden="false">edit_note</mat-icon>
          <span>{{ hasAccessToEditCompany() ? "EDITAR" : "VISUALIZAR" }}</span>
        </button>
      </div>
    </div>
  </div>
  <div class="more-companies-container">
    <button class="more-companies-btn" *ngIf="showMoreCompaniesBtn()" type="button" (click)="searchMoreCompanies()" aria-label="Carregar mais empresas">
      <span class="btn-title">carregar mais registros</span>
    </button>
  </div>
  <div id="bottom"></div>
</div>
